type InviewTweenVars = Record<string, any>

export class InviewAnim {
	el: any
	from: InviewTweenVars
	to: InviewTweenVars | InviewTweenVars[]
	settings: InviewTweenVars

	constructor(el: any, from: InviewTweenVars, to: InviewTweenVars | InviewTweenVars[], settings: InviewTweenVars) {
		this.el = el
		this.from = from
		this.to = to
		this.settings = settings
	}

	setFrom(): void {
		gsap.set(this.el, this.from)
	}

	get animation() {
		if (Array.isArray(this.to)) {
			const tl = gsap.timeline()
			for (const step of this.to) {
				const { at, ...stepVars } = step as InviewTweenVars & { at?: number | string }
				const vars = { ...this.settings, ...stepVars }
				if (at !== undefined) {
					tl.to(this.el, vars, at)
				} else {
					tl.to(this.el, vars, 0)
				}
			}
			return tl
		}
		return gsap.to(this.el, { ...this.to, ...this.settings })
	}
}

